import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Alert,
  Typography,
} from '@mui/material';
import { deleteCharger } from '../../services/chargerService';

const DeleteChargerModal = ({ isOpen, onClose, charger, onChargerDeleted }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: '', message: '' });

  const handleSubmit = async () => {
    setIsLoading(true);
    setFeedback({ type: '', message: '' });
    try {
      await deleteCharger(charger.charger_id);
      setFeedback({ type: 'success', message: 'Cargador eliminado correctamente.' });
      setTimeout(() => {
        onChargerDeleted();
        onClose();
      }, 1500);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error al eliminar el cargador.';
      setFeedback({ type: 'error', message: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Eliminar Cargador</DialogTitle>
      <DialogContent>
        <Typography>
          ¿Estás seguro de que deseas eliminar el cargador con ID: {charger?.charger_id}?
        </Typography>
        {feedback.message && (
          <Alert severity={feedback.type} sx={{ mt: 2 }}>
            {feedback.message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} disabled={isLoading} color="error">
          {isLoading ? <CircularProgress size={24} /> : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteChargerModal;
